<template>
  <div class="MyAccountPage">
    <header-banner>
      <div class="banner-content container">
        <p class="welcome">
          {{ $t('header.welcome', 'Welcome back') }}, {{ profile.personalDetail.firstName }}
        </p>

        <my-account-nav-mobile
          class="show-mobile"
          :menu-options="menuOptions"
        />
      </div>
    </header-banner>

    <div class="container MyAccountPage-sub">
      <my-account-menu :menu-options="menuOptions" />

      <div class="MyAccount_View">
        <invalid-payment-profile
          :content="$t('myaccount.paymentDetails.invalidPaymentProfile.text', 'There seems to be a problem with your payment. Please update your card details or select a different payment method.')"
          :show-button="showGoChangePayment"
          v-if="paymentActivity.hasInvalidRecurringPaymentDetail"
        />
        <invalid-payment-profile
          :content="$t('myaccount.paymentDetails.initialPaymentInProgress.text', 'The payment is still under authorisation, the subscription will be created after the payment is authorized.')"
          :show-button="false"
          v-if="paymentActivity.hasInitialPaymentInProgress"
        />
        <router-view />
      </div>
    </div>
  </div>
</template>

<script>
  import HeaderBanner from 'components/HeaderBanner'
  import MyAccountNavMobile from 'components/MyAccountNavMobile'
  import MyAccountMenu from 'components/MyAccountMenu'
  import InvalidPaymentProfile from 'components/InvalidPaymentProfile'
  import { mapState } from 'vuex'
  import { detectedCulture } from '@/utilities/common/culture'

  export default {
    name: 'my-account',

    components: {
      HeaderBanner,
      MyAccountNavMobile,
      MyAccountMenu,
      InvalidPaymentProfile
    },

    beforeRouteEnter (to, from, next) {
      next(vm => {
        if (vm.$route.name === 'my-account') {
          vm.$router.replace({ name: 'overview' })
        }
      })
    },

    computed: {
      ...mapState('account', {
        profile: state => state.profile,
        paymentActivity: state => state.paymentActivity
      }),
      showGoChangePayment () {
        return this.$route.name !== 'payment-details'
      },
      queryLanguage () {
        if (detectedCulture.code === 'en-ca' && window.localStorage.getItem('canadaLanguage')) {
          return window.localStorage.getItem('canadaLanguage')
        }
          if (detectedCulture.code === 'nl-be' && window.localStorage.getItem('belgiumLanguage')) {
          return window.localStorage.getItem('belgiumLanguage')
        }
      },

      menuOptions () {
        return [
          { code: 'Overview',
            name: this.$t('myaccount.nav.overview', 'Overview'),
            route: { path: '/my-account/overview', query: { language: this.queryLanguage } },
            analyticsCode: 'my_account:overview' },
          { code: 'Personal details',
            name: this.$t('myaccount.nav.personalDetails', 'Personal details'),
            route: { path: '/my-account/personal-details', query: { language: this.queryLanguage } },
            analyticsCode: 'my_account:personal_details' },
          { code: 'Payment details',
            name: this.$t('myaccount.nav.paymentDetails', 'Payment details'),
            route: { path: '/my-account/payment-details', query: { language: this.queryLanguage } },
            analyticsCode: 'my_account:payment_method' },
          { code: 'Billing',
            name: this.$t('myaccount.nav.billing', 'Billing'),
            route: { path: '/my-account/billing', query: { language: this.queryLanguage } },
            analyticsCode: 'my_account:billing' },
          { code: 'Support',
            name: this.$t('myaccount.nav.support', 'Support'),
            route: { path: '/my-account/support', query: { language: this.queryLanguage } },
            analyticsCode: 'my_account:support' }
        ]
      }
    },

    created () {
      this.$store.dispatch('account/fetchProfile')
      if (this.isCanadaSite && this.$route.name !== 'payment-result') {
        if (!this.$route.query.language) {
          this.$router.push({
            query: {
              language: 'en-CA'
            }
          })
        } else {
          this.$router.push({
            query: {
              language: this.queryLanguage
            }
          })
        }
        window.localStorage.setItem('canadaLanguage', this.$route.query.language)
      }
    }
  }
</script>

<style lang="scss">
  .MyAccount {
    &Page {
      @include media(tablet) {
        background: #f2f2f2;
      }

      .HeaderBanner {
        @include media(tablet) {
          height: 3.49rem;
        }
      }

      .banner-content {
        position: absolute;
        width: 100%;
        z-index: 100;
        left: 0;
        right: 0;
        top: 50%;
        transform: translateY(-50%);

        .welcome {
          color: $white;
          font-size: .24rem;
          font-weight: 300;
          margin-bottom: .05rem;

          @include media(tablet) {
            font-size: .36rem;
            font-weight: 400;
            margin-bottom: 0;
          }
        }
      }

      &-sub {
        @include media(tablet) {
          display: flex;
          flex-wrap: nowrap;
          margin-top: -.7rem;
          padding-bottom: 1rem;
        }
      }
    }

    &_View {
      position: relative;
      min-height: 3.2rem;
      padding: .3rem 0;

      @include media(tablet) {
        flex: 2;
        padding: .52rem .23rem;
        background: $white;
        min-height: 6.4rem;
      }

      .title {
        color: $font-black;
        line-height: 1;
        font-size: .24rem;
        padding: 0 .1rem .08rem;

        @include media(tablet) {
          border-bottom: .01rem solid #9b9b9b;
          padding: 0 .15rem .12rem;
        }
      }
    }

    &Form {
      .Form_group {
        margin-bottom: 0;
      }

      .Form_label {
        font-size: .16rem;
        color: #666;
        line-height: .25rem;
        padding: .1rem .15rem 0;
      }

      .AppCheckbox {
        + .Form_label {
          padding: 0;
        }
      }

      .Form_control {
        padding: 0 .15rem .1rem;
        font-size: .18rem;
        line-height: .25rem;
      }

      .AppButton {
        margin-top: .28rem;
      }

      .multiselect__placeholder {
        font-size: .18rem;
        line-height: .25rem;
      }
    }
  }
</style>
